import axios from "axios";
import Constants from "../../../components.constants.js";


export default {

  async getAllUserGroupsFromServer(context, payload = {}) {
    try {
      let resp = await axios.get(Constants.userGroupsUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      }else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getAllUserGroupsFromServer][Store][Error occured while getting userGroupslist--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async addNewUserGroup(context, payload = {}) {
    //payload : FUSION Users JSON schema

    try {
      let resp = await axios.post(Constants.userGroupsUrl, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[addNewUserGroup][Store][UserGroup add resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[addNewUserGroup][Store][Error occured while adding UserGroup--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async updateExistingUserGroup(context, payload = {}) {
    //payload : {params:{groupId: "23412123"}, data:DAM Users JSON schema}

    try {
      let resp = await axios.put(`${Constants.userGroupsUrl}/${payload.params._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[updateExistingUserGroup][Store][UserGroup update resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[updateExistingUserGroup][Store][Error occured while updating UserGroup--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

  async deleteExistingUserGroup(context, payload = {}) {
    //payload : {params:{groupId: "23412123"}, data:DAM Users JSON schema}

    try {
      let resp = await axios.delete(`${Constants.userGroupsUrl}/${payload._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        console.log(
          `[deleteExistingUserGroup][Store][UserGroup Delete resp-->${resp.status}]`
        );
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[deleteExistingUserGroup][Store][Error occured while deleting UserGroup--->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }

  },

  async getUserGroupInfoFromServer(context, payload = {}) {
    //payload : {params:{groupId:"3422344231"}}

    try {
      let resp = await axios.get(`${Constants.userGroupsUrl}/${payload.params._id}`, payload);
      if (Constants.acceptedStatusCodes.includes(resp.status)) {
        resp.data.statusCode = resp.status
        return resp.data;
      } else {
        throw `Response from server-->${resp.status}, data--->${resp.data}, statusText-->${resp.statusText}`;
      }
    } catch (error) {
      console.error(
        `[getUserGroupInfoFromServer][Store][Error occured while getting userGroupinfo --->${error}]`
      );
      if (error.response) {
        if (error.response.status == 401){
          return context.dispatch("users/logOutFromServer", {},{root:true})
        }
        else {
          error.response.data.statusCode = error.response.status
          return error.response.data
        }
      }
      return {}
    }
  },

};
